'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import request from 'superagent'
import classnames from 'classnames'

import Alert from '@argos/alert'

import './StarRating.scss'

class StarRating extends React.Component {
  constructor () {
    super()
    this.formStates = {
      NOSUBMIT: 0,
      ERROR: 1,
      SUCCESS: 2
    }
    this.state = {
      vote: null,
      feedback: '',
      feedbackArea: false,
      submitState: this.formStates.NOSUBMIT
    }
    this.initialState = this.state

    this.sendRequest = this.sendRequest.bind(this)
    this.voteSubmit = this.voteSubmit.bind(this)
    this.handleCommentSubmit = this.handleCommentSubmit.bind(this)
    this.handleCommentChange = this.handleCommentChange.bind(this)
  }

  componentWillReceiveProps (newProps) {
    const { faqId, pageId } = this.props

    // Reset the state when the FAQ/Page ID prop changes
    if ((faqId && faqId !== newProps.faqId) || (pageId && pageId !== newProps.pageId)) {
      this.setState(this.initialState)
    }
  }

  sendRequest (inputVote, inputComment) {
    const postUrl = '/help/api?action=sendRatings'
    const postData = {
      vote: inputVote,
      voteComment: inputComment,
      voteType: this.props.faqId ? 'faq' : 'page',
      voteTypeId: this.props.faqId ? this.props.faqId : this.props.pageId
    }
    request.post(postUrl).type('form')
      .send(postData)
      .end((err, response) => {
        if (err !== null || response.text === 'false') {
          this.setState({
            submitState: this.formStates.ERROR
          })
        } else {
          this.setState({
            submitState: this.formStates.SUCCESS
          })
        }
      })
  }

  voteSubmit (e, voteNumber) {
    this.setState({ vote: voteNumber })

    if (voteNumber <= 3) {
      this.setState({ feedbackArea: true })
    } else {
      this.setState({ feedbackArea: false })
      this.sendRequest(voteNumber, '')
    }
    e.preventDefault()
  }

  handleCommentSubmit (e) {
    const checkCommentSubmit = e.target.getAttribute('data-comment-btn') ? this.state.feedback : '' && this.setState({ feedback: '' })
    this.setState({ feedbackArea: false })
    this.sendRequest(this.state.vote, checkCommentSubmit)
    e.preventDefault()
  }

  handleCommentChange (evt) {
    this.setState({ feedback: evt.target.value.substr(0, 500) })
  }

  render () {
    const ccn = 'star-rating'
    const stars = [5, 4, 3, 2, 1]
    const { vote } = this.state
    return (
      <div className={ccn}>
        <h3 className={ccn + '__title h2'}>Was this answer helpful?</h3>
        <form className={ccn + '__form ' + ccn + '__form--rating form-inline'} action='#' method='post'>
          <input type='hidden' name='artikel' value='9' />
          {
            (this.state.submitState === this.formStates.ERROR || this.state.submitState === this.formStates.NOSUBMIT) &&
            <div className={ccn + '__rating'} data-votetype='faq'>
              {
                stars.map((star, i) => {
                  const activeStar = classnames([ccn + '__star'], { [ccn + '__star--selected']: star === vote })
                  return (
                    <span className={activeStar} onClick={(e) => this.voteSubmit(e, star)} key={i} role='button' tabIndex='0' aria-label={star + ' Star'}>
                      <span aria-hidden='true'>☆</span>
                    </span>
                  )
                })
              }
            </div>
          }
        </form>
        {
          this.state.submitState === this.formStates.ERROR &&
          <Alert className={ccn + '__alert'} backgroundColor='white' borderColor='red' textColor='red'>
            We don't count multiple votes (sorry)
          </Alert>
        }
        {
          this.state.submitState === this.formStates.SUCCESS &&
          <Alert className={ccn + '__alert'} backgroundColor='white' borderColor='green' textColor='green'>
            Many thanks for your feedback. We'll certainly take it on board to give you the best experience possible.
          </Alert>
        }
        {
          this.state.feedbackArea === true &&
          <div id='feedbackArea' className={ccn + '__feedback'}>
            <form id='formMakeComment' action='#' method='post' name='formMakeComment'>
              <div className='form-group col-xs-12'>
                <label className={ccn + '__feedback__label'} htmlFor='comment'>Please tell us how this FAQ could be more helpful...</label>
                <textarea rows='4' name='comment' id='comment' className='form-control' onChange={this.handleCommentChange} maxLength='500' />
                <input type='hidden' id='type' name='type' value='faq' />
                <input type='hidden' id='id' name='id' value='9' />
                <input type='hidden' id='vote' name='vote' value='' />
                <input type='hidden' id='lang' name='en' />
                <div id='textarea_feedback' className='char_count_green' />
              </div>
              <div className={ccn + '__row'}>
                <button className={ccn + '__button button button--primary button--block'} id='commentSubmit' type='submit' data-comment-btn='submit' disabled={!this.state.feedback} onClick={this.handleCommentSubmit}>Submit Comment</button>
                <button className={ccn + '__button button button--secondary button--block'} id='commentClose' type='button' data-comment-btn='' onClick={this.handleCommentSubmit}>No Thanks</button>
              </div>
            </form>
          </div>
        }
      </div>
    )
  }
}

StarRating.propTypes = {
  faqId: PropTypes.number,
  pageId: PropTypes.number
}

export default StarRating
